import ACTIONS from '../actions.js'

export function useTemplateActions(dispatch) {
  return {
    setRequestTemplate: value =>
      dispatch({ type: ACTIONS.SET_REQUEST_TEMPLATE, value }),
    setTemplateDocuments: value =>
      dispatch({ type: ACTIONS.SET_TEMPLATE_DOCUMENTS, value }),
    setDateRange: (key, value) =>
      dispatch({ type: ACTIONS.SET_DATE_RANGE, key, value }),
    setDueDate: value => dispatch({ type: ACTIONS.SET_DUE_DATE, value }),
    toggleDocumentSelection: id =>
      dispatch({ type: ACTIONS.TOGGLE_DOCUMENT_SELECTION, id }),
    addOtherInput: () => dispatch({ type: ACTIONS.ADD_OTHER_INPUT }),
    updateOtherInput: (index, value) =>
      dispatch({ type: ACTIONS.UPDATE_OTHER_INPUT, index, value }),
    removeOtherInput: index =>
      dispatch({ type: ACTIONS.REMOVE_OTHER_INPUT, index }),
    setPerDocumentDate: (docId, field, value) =>
      dispatch({ type: ACTIONS.SET_PER_DOCUMENT_DATE, docId, field, value }),
    setPerOtherInputDate: (index, field, value) =>
      dispatch({ type: ACTIONS.SET_PER_OTHER_INPUT_DATE, index, field, value }),
    setSpecialInstructions: value =>
      dispatch({ type: ACTIONS.SET_SPECIAL_INSTRUCTIONS, value }),
    addAssignee: () => dispatch({ type: ACTIONS.ADD_ASSIGNEE }),
    removeAssignee: index => dispatch({ type: ACTIONS.REMOVE_ASSIGNEE, index }),
    updateAssignee: (index, assignee) =>
      dispatch({ type: ACTIONS.UPDATE_ASSIGNEE, index, assignee }),
    updateAssigneeField: (index, field, value) =>
      dispatch({ type: ACTIONS.UPDATE_ASSIGNEE_FIELD, index, field, value }),
  }
}

export default useTemplateActions
